import { render, staticRenderFns } from "./ListaAttivita.vue?vue&type=template&id=21ae5f33&"
import script from "./ListaAttivita.vue?vue&type=script&lang=js&"
export * from "./ListaAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports